const docsURL = process.env.NODE_ENV === 'development' ? 'http://d2i3xvppj0wsd6.cloudfront.net' : 'https://docs.wallboard.risexperience.solutions';

export { docsURL };
